import { View, Text, IconEdit } from '@acin/ui-core';
import styled, { css } from 'styled-components';

export const DocumentSwitcher = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Document = styled.button<{ isSingle?: boolean }>`
  border: 0;
  padding: 0;
  padding-right: ${(p) => p.theme.spacing.getSize(2)};
  border-right: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  margin-right: ${(p) => p.theme.spacing.getSize(2)};
  display: flex;
  flex-direction: row;
  background: none;
  justify-content: center;
  align-items: center;
  max-width: ${(p) => p.theme.spacing.getSize(95)};

  &:focus {
    outline: 0;
  }

  &:hover {
    cursor: pointer;
  }

  ${(p) =>
    p.isSingle &&
    css`
      border-right: none;
      margin-right: 0;
    `}
`;

export const Name = styled(Text)`
  margin-left: ${(p) => p.theme.spacing.getSize()};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Icon = styled(IconEdit)`
  margin-left: ${(p) => p.theme.spacing.getSize(2)};
`;
